module.exports = __webpack_public_path__ + "static/img/面数.4724d34c.png";